<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-panel-header-setting-popup right">
    <el-dropdown ref="configureDropdown" trigger="click" @visible-change="handleChangeVisible">
        <el-tooltip content="configure" placement="bottom">
            <el-button class="setting-icon" plain>
                <img class="setting-img" src="../../assets/icons/icon_setting.svg" alt="setting icon">
                <i class="el-icon-arrow-down el-icon--right setting-arrow-down"></i>
            </el-button>
        </el-tooltip>
        <el-dropdown-menu slot="dropdown" class="wy-panel-header-setting" :class="{'handling-time-header-settig': controller.pannelData&&controller.pannelData.filterSettings&&controller.pannelData.filterSettings.buckets}">
            <div class="gear-panel" v-if="controller" @mouseover="controller.mouseover">
                <div class="gear-header">
                    Configure
                    <img @click="handleCloseDropdown" class="close-img" src="../../assets/icons/icon_customer_close.svg" alt="close configure dropdown icon">
                </div>
                <div class="gear-flex">
                    <div class="gear-top">
                      <div class="performance-compare-group-by">
                        <el-select
                        v-model="selectedDateRange"
                        collapse-tags
                        size="mini"
                        style="margin-left: 5px;"
                        class="date-range-dropdown"
                        @visible-change="handleSelected"
                        popper-class="table-filter-dropdown date-range"
                        :popper-append-to-body="false"
                        @change="dateRangeChanged(selectedDateRange)">
                          <el-option
                            v-for="(item) in dateRangeTypes"
                            :disabled="item.disabled"
                            :key="item.type"
                            :label="item.label"
                            :value="item.type">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div v-if="controller.pannelData&&controller.pannelData.filterSettings&&controller.pannelData.filterSettings.buckets" :class="{'buckets-section': controller.pannelData&&controller.pannelData.filterSettings&&controller.pannelData.filterSettings.buckets}">
                      <div class="gear-middle" v-for="(bucket, bucketIndex) in controller.pannelData.filterSettings.buckets" :key="bucketIndex">
                        <div class="sub-headers">{{bucket.title}}</div>
                        <div class="gear-row" v-for="(inputNumber, index) in bucket.numberRange" :key="index">
                          <span class="index">{{index + 1}}. </span>
                          <!-- <span class="start-less-than" v-if="index==bucket.numberRange.length-1">&#60;</span> -->
                          <el-input-number 
                            v-show="index>0"
                            v-model="inputNumber.startNumber" 
                            :min="getMinStartValue(index, bucket.numberRange)"
                            :max="getMinStartValue(index, bucket.numberRange)"
                            :step=1
                            width="40" 
                            size="mini" 
                            controls-position="right">
                          </el-input-number>
                          <span v-if="index>=bucket.numberRange.length-1" class="plus">+</span>
                          <span v-if="index>0 && index<bucket.numberRange.length-1" class="dash">-</span>
                          <!-- <span class="end-less-than" v-if="index<bucket.numberRange.length-1">&#60;</span> -->
                          <el-input-number 
                            v-show="index<bucket.numberRange.length-1" 
                            v-model="inputNumber.endNumber" 
                            :min="getMinEndValue(index, bucket.numberRange)"
                            :max=100000
                            :step=1
                            width="40" 
                            size="mini" 
                            controls-position="right">
                          </el-input-number>
                          <el-tooltip content="delete range" v-if="index>0 && bucket.numberRange.length>2 && index<bucket.numberRange.length-1" placement="bottom">
                            <img class="garbage-can-img" src="../../assets/icons/icon_customer_garbage_can.svg" alt="delete icon" @click="removeNumberRange(index, bucket)">
                          </el-tooltip>
                        </div>
                        <div class="add-fiter gear-row" v-if="bucket && bucket.numberRange && bucket.numberRange.length < bucket.maxNumRange">
                          <el-tooltip content="add range" placement="bottom">
                            <img class="add-filter-img" src="../../assets/icons/icon_customer_add_filter.svg" alt="add filter icon" @click="addNumberRange(bucket)">
                          </el-tooltip>
                          Add filter</div>
                      </div>
                    </div>
                    
                </div>
            </div>
            <div v-if="controller.pannelData&&controller.pannelData.filterSettings&&controller.pannelData.filterSettings.buckets" class="apply-div">
              <el-button plain class="reset-btn" @click="handleReset"><span class="apply-text">Reset</span></el-button>
              <el-button plain class="cancel-btn" @click="handleCancel"><span class="apply-text">Cancel</span></el-button>
              <el-button plain class="apply-btn" @click="handleApply"><span class="apply-text">Apply</span></el-button>
            </div>
        </el-dropdown-menu>
    </el-dropdown>
    <!-- <el-tooltip content="save to my dashboard" placement="bottom">
        <img class="bookmark-img" src="../../assets/icons/icon_bookmark.svg" alt="bookmark icon">
    </el-tooltip>
    <el-tooltip content="move" placement="bottom">
        <img class="move-info" src="../../assets/icons/icon_overview_performance_move.svg" alt="move icon">
    </el-tooltip> -->
  </div>
</template>

<script>
  import Vue from 'vue';
  import moment from 'moment';
  import { mapGetters } from 'vuex';

  export default Vue.extend({
      name: 'wy-panel-header-setting-popup',
      props: ["controller"],

      data() {
      return {
          isApplied: false,
          temDateRange: 'month',
          tempBuckets: {},
          selectedDateRange: 'month',
          dateRangeTypes: {
            'year': {
                type: 'year',
                label: 'View by year',
                tickformat: '%Y',
                disabled: false
            },
            // 'quarter': {
            //     type: 'quarter',
            //     label: 'View by quarter',
            //     tickformat: '%b %d %Y',
            //     disabled: false
            // },
            'month': {
                type: 'month',
                label: 'View by month',
                tickformat: '%b %Y',
                disabled: false
            },
            'week': {
                type: 'week',
                label: 'View by week',
                tickformat: '%b %d %Y',
                disabled: false
            },
            'day': {
                type: 'day',
                label: 'View by day',
                tickformat: '%b %d %Y',
                disabled: false
            }
          },
          numberRange: [
            {
              startNumber: 0,
              endNumber: 1
            },
            {
              startNumber: 1,
              endNumber: 2
            },
            {
              startNumber: 2,
              endNumber: null
            }
          ]
      }},

      watch: {
        'controller.dataIndex': {
          immediate: false,
          handler() {
            // console.log("tab changed.....")
            // this.checkDailyOption();
          }
        },

        'controller.sectionData': {
          immediate: false,
          handler() {
            // console.log("sectionData changed.....")
            // this.checkDailyOption();
          }
        },
        'dataModel.dateEnd': {
          immediate: true,
          handler() {
            // console.log("date range changed....")
            // this.checkDailyOption();
          }
        }
      },

      computed: {
        ...mapGetters(['dataModel']),
      },

      methods: {
        handleChangeVisible(isOpen) {
          if(isOpen){
            this.isApplied = false;
            this.temDateRange = this.selectedDateRange;
            if(this.controller.pannelData.filterSettings && this.controller.pannelData.filterSettings.buckets) {
              this.tempBuckets = JSON.parse(JSON.stringify(this.controller.pannelData.filterSettings.buckets));
            }
          }
          else {
            if(this.isApplied) {
              this.isApplied = false;
            }
            else {
              if(this.controller.pannelData.filterSettings && this.controller.pannelData.filterSettings.buckets) {
                this.selectedDateRange = this.temDateRange;
                this.controller.pannelData.filterSettings.buckets = JSON.parse(JSON.stringify(this.tempBuckets));
              }
            }
          }
        },
        handleCloseGearPopup(){
          if(document.querySelector(".table-filter-dropdown"))document.querySelector(".table-filter-dropdown").blur()
        },
        handleHidePopper(isScroll){
          if(isScroll && this.$refs.configureDropdown){
            this.$refs.configureDropdown.hide()
          }
        },
        handleReset() {
          this.selectedDateRange = this.temDateRange;
          this.controller.pannelData.filterSettings.buckets = JSON.parse(JSON.stringify(this.tempBuckets));
        },

        handleCancel() {
          this.selectedDateRange = this.temDateRange;
          this.controller.pannelData.filterSettings.buckets = JSON.parse(JSON.stringify(this.tempBuckets));
          this.$refs.configureDropdown.hide();
        },

        handleApply() {
          this.$refs.configureDropdown.hide()
          this.controller.changeDateRange(this.selectedDateRange);
          this.isApplied = true;
          // this.handleCloseDropdown()
          this.$root.$emit(`fire-selected-date-change-events`, this.selectedDateRange);
        },
        dateRangeChanged(selectedDateRange) {
          if(!this.controller.pannelData.filterSettings) {
            this.controller.changeDateRange(selectedDateRange)
          }
        },
        handleSelected(isOpen){
          if(!isOpen && !this.controller.pannelData.filterSettings){
            this.$refs.configureDropdown.hide()
            this.$root.$emit(`fire-selected-date-change-events`, this.selectedDateRange);
          }
        },
        handleCloseDropdown(){
          if(this.controller.filterNumberRangeChanged && this.controller.pannelData.filterSettings.buckets) {
            this.controller.filterNumberRangeChanged();
          }
          this.$refs.configureDropdown.hide();
        },
        checkDailyOption() {
          let dateStartMoment = moment(this.dataModel.dateStart,'YYYY-MM-DD');
          let dateEndMoment = moment(this.dataModel.dateEnd,'YYYY-MM-DD');
          this.dateRangeDatesDiff = dateEndMoment.diff(dateStartMoment, 'days', true);  
          // console.log("this.dateRangeDatesDiff > 30", this.dateRangeDatesDiff > 30, this.dateRangeTypes, this.controller.sectionData.columnChartData)
          if(this.dateRangeDatesDiff + 1 > 60  && this.controller.sectionData && this.controller.sectionData.columnChartData) {
            this.dateRangeTypes.day.disabled = true
            // console.log(this.selectedDateRange)
            if(this.selectedDateRange == 'day') {
              this.selectedDateRange = 'week'
              this.dateRangeChanged(this.selectedDateRange)
            }
          }
          else {
            this.dateRangeTypes.day.disabled = false
          }
        },
        getDisabled(item) {
          if(this.dataModel.dateStart && this.dataModel.dateStart) {
            let dateStartMoment = moment(this.dataModel.dateStart,'YYYY-MM-DD');
            let dateEndMoment = moment(this.dataModel.dateEnd,'YYYY-MM-DD');
            this.dateRangeDatesDiff = dateEndMoment.diff(dateStartMoment, 'days', true);   
            // console.log(this.controller, item.type)
            if(this.dateRangeDatesDiff > 30 && item.type == 'day') {
              return true;
            }
            else {
              return false;
            }
          }
          else {
            return true;
          }
          // return false
        },
        getMinStartValue(index, numberRange) {
          if(index == 0) {
            return 0
          }
          else {
            numberRange[index].startNumber = numberRange[index - 1].endNumber;
            if(numberRange[index].endNumber <= numberRange[index].startNumber) {
              numberRange[index].endNumber = numberRange[index].startNumber + 1
            }
            return numberRange[index - 1].endNumber;
          }
        },

        getMinEndValue(index, numberRange) {
          // console.log("change.....")
          return numberRange[index].startNumber + 1;
        },

        addNumberRange(bucket) {
          if(bucket.numberRange.length < bucket.maxNumRange) {
            let length = bucket.numberRange.length - 1;
            let addItem = {};
            addItem.startNumber = bucket.numberRange[length - 1].endNumber;
            addItem.endNumber = addItem.startNumber + 1;
            bucket.numberRange.splice(length, 0, addItem);
            bucket.numberRange[bucket.numberRange.length - 1].startNumber = addItem.endNumber
            bucket.numberRange[bucket.numberRange.length - 1].endNumber = null
          // console.log(bucket, bucket.numberRange)
          }
        },

        removeNumberRange(index, bucket) {
          bucket.numberRange.splice(index, 1);
          // console.log(bucket, bucket.numberRange)
        },

        handlePopperHide(){
          this.$refs.configureDropdown.hide()
        }
      },
      destroyed() {
        window.removeEventListener("resize", this.handlePopperHide);
      },
      mounted(){
        this.$root.$on(`fire-app-hide-popper-events`, (isScroll) => {
          this.handleHidePopper(isScroll);
        });
        this.selectedDateRange = this.controller.dateRange
        window.addEventListener("resize", this.handlePopperHide)

        if(this.controller.dataModel.dateRangeInDays > 0 && this.controller.dataModel.dateRangeInDays < 7){
            this.dateRangeTypes.week.disabled = true
            this.dateRangeTypes.month.disabled = true
            this.dateRangeTypes.year.disabled = true
            this.dateRangeTypes.day.disabled = false
          } else if(this.controller.dataModel.dateRangeInDays >= 7 && this.controller.dataModel.dateRangeInDays < 30){
            this.dateRangeTypes.month.disabled = true
            this.dateRangeTypes.year.disabled = true
            this.dateRangeTypes.week.disabled = false
            this.dateRangeTypes.day.disabled = false
          } else if(this.controller.dataModel.dateRangeInDays >= 30 && this.controller.dataModel.dateRangeInDays < 365){
            this.dateRangeTypes.year.disabled = true
            this.dateRangeTypes.week.disabled = false
            this.dateRangeTypes.day.disabled = false
            this.dateRangeTypes.month.disabled = false
          }
          else {
            this.dateRangeTypes.year.disabled = false
            this.dateRangeTypes.week.disabled = false
            this.dateRangeTypes.day.disabled = false
            this.dateRangeTypes.month.disabled = false
          }


        this.$root.$on(`date-filter-change-events`,days => {
          if(days > 0 && days < 7){
            this.dateRangeTypes.week.disabled = true
            this.dateRangeTypes.month.disabled = true
            this.dateRangeTypes.year.disabled = true
            this.dateRangeTypes.day.disabled = false
          } else if(days >= 7 && days < 30){
            this.dateRangeTypes.month.disabled = true
            this.dateRangeTypes.year.disabled = true
            this.dateRangeTypes.week.disabled = false
            this.dateRangeTypes.day.disabled = false
          } else if(days >= 30 && days < 365){
            this.dateRangeTypes.year.disabled = true
            this.dateRangeTypes.week.disabled = false
            this.dateRangeTypes.day.disabled = false
            this.dateRangeTypes.month.disabled = false
          }
          else {
            this.dateRangeTypes.year.disabled = false
            this.dateRangeTypes.week.disabled = false
            this.dateRangeTypes.day.disabled = false
            this.dateRangeTypes.month.disabled = false
          }
        });
        if(document.querySelector(".wy-container-main ")){
          document.querySelector(".wy-container-main ").addEventListener('scroll', this.handleCloseGearPopup);
        }
      }

  });
</script>

<style lang="scss">
  button.el-button.gear-dropdowns.el-button--default.is-plain.el-dropdown-selfdefine {
    border-radius: 5px;
    margin: 10px;
    padding: 5px;
  }
  .performance-compare-group-by{
    .el-select.date-range-dropdown.el-select--mini{
      width: 7.86vw !important;
      min-width: 128px;
      border: 1px #DCDFE6 solid;
      border-radius: 5px;
      position: relative;
      right: 0.24vw;
    }
    .el-select.date-range-dropdown.el-select--mini:active{
      border: 1px solid #1C4DB2;
    }
    input.el-input__inner {
      border-width: 0px 0px 1px 0px !important;
      border-radius: 5px;
      padding-left: 5px;
    }
    .el-input__inner {
      border: 1px solid transparent !important;
      &:hover{
        background: #F4F6F8;
      }
    }
  }

  .buckets-section{
    .el-input-number--mini {
      width: 97px !important;
      margin-top: 10px !important;
      line-height: 26px !important;
    }
    .gear-middle {
      margin-left: 20px !important;
    }
    .index{
      color: #828E9A;
      font-size: 12px !important;
      position: relative;
      right: 7px;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    }
    .sub-headers{
      font-weight: 500 !important;
      font-size: 14px !important;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
      margin-top: 15px !important;
      margin-bottom: 5px !important;
    }
    .garbage-can-img{
      margin-left: 9px !important;
      cursor: pointer;
      &:hover{
        background: #F4F6F8;
      }
    }
    .add-fiter.gear-row {
      margin-top: 10px !important;
      margin-left: 0px !important;
      font-size: 12px !important;
    }
    .dash{
      color: #CAD2DA !important;
      margin-left: 2px !important;
      margin-right: 2px !important;
    }
    .plus{
      position: relative;
      right: 54px;
      bottom: 1px;
      margin-left: 2px !important;
      margin-right: 2px !important;
      font-size: 14px;
      color: var(--site-font-tertiary-color);
    }
    
  }
  .wy-panel-header-setting-popup {
    position: relative;
    left: 20px;
    .gear-middle, .gear-bottom{
        margin-top: 20px;
        padding: 5px 20px;
    }
    .sub-headers{
        font-weight: 500;
        font-size: 14px;
    }
    .gear-bottom{
        padding-bottom: 15px;
    }

    .gear-panel{
      background: #ffffff;
      border: 1px solid #CAD2DA !important;
      box-sizing: border-box;
      border-radius: 10px;
      margin-top: -15px;
      margin-bottom: -15px;
    }

    .setting-icon {
      padding: 0px 3px 8px 7px;
      position: relative;
      // top: 6px;
      // bottom: 10px;
    }
    .bookmark-img{
      position: relative;
      bottom: 7px;
      width: 15px;
      user-select: none !important;
      margin-right: 15px;
    }
    .setting-img{
      position: relative;
      user-select: none !important;
      right: 1px;
      width: 18px;
      top: 0vw !important;
      &:active{
        background: #E8F1FF;
        color: #1C4DB2;
        border-radius: 50%;
      }
    }
  }
  
  .handling-time-header-settig{
    height: 444px;
    overflow: hidden hidden;
    .gear-panel{
      // overflow: hidden scroll;
      height: 400px;
      .gear-flex {
        height: 356px;
        overflow: hidden scroll;
      }
    }
  }
  .wy-panel-header-setting {
    .gear-top{
      display: flex !important;
      align-items: center;
      padding: 10px 20px 0px 20px;
      font-weight: 500;
      font-size: 14px;

      .table-filter-dropdown .el-select-dropdown__item {
        height: 29px;
        line-height: 33px;
        font-weight: normal;
        font-size: 14px;
        padding: 0 10px;
        margin: 2px 0px 0px 0px !important;
        &:hover{
          background: #F4F6F8 !important;
        }
        &:active{
          background: #E8F1FF !important;
          color: #1C4DB2;
        }
      }
      .table-filter-dropdown .el-select-dropdown__item.selected {
        border: none;
        background-image: none !important;
        background: #E8F1FF;
        color: #1C4DB2;
      }
    }

    .gear-panel {
      margin-bottom: 0px;
      width: 274px;
      // height: 80px;
    }
    .el-input__inner {
      font-family: "Helvetica Neue", Helvetica !important;
      border-radius: 5px;
      padding: 8px 12px;
      font-size: 14.22px;
      font-family: Helvetica Neue, Helvetica;
      color: var(--site-font-tertiary-color);
      font-weight: normal;
      &:hover{
        background: #F4F6F8;
      }
    }
    .gear-header {
      border-bottom: 1px solid #CAD2DA;
      margin-bottom: 0px;
      padding: 14px 12px 12px 20px !important;
      font-weight: 500;
      font-size: 14.22px;
    }
    
    .add-filter-img{
      position: relative;
      margin-right: 5px;
      user-select: none !important;
      width: 11px;
      cursor: pointer;
      &:hover{
        background: #F4F6F8;
      }
    }
    .close-img{
      width: 10px;
      cursor: pointer;
      user-select: none !important;
      float: right;
      position: relative;
      top: -10px;
      &:hover{
        background: #F4F6F8;
      }
    }
    .gear-row{
      width: 300px;
    }
    .add-fiter.gear-row{
      font-size: 12px !important;
      display: flex;
    }
    .apply-div{
      height: 44px;
      border-top: 0.5px solid #CAD2DA;
      padding-top: 6px;
      .apply-btn ,.reset-btn, .cancel-btn{
        position: relative;
        bottom: -6px;
        right: 27px;
        // right: 174px;
        font-size: 14px;
        color: var(--site-font-chart-color);
        width: 55px;
        height: 30px;
        border-radius: 4px;
        padding: 0px;
        float: right;
        .char {
          margin-left: auto;
          color: #d2d2d2;
        }
        .apply-text{
          position: relative;
          // right: 21px;
          font-weight: normal;
          font-size: 14px;
        }
      }
      .reset-btn {
        float: left;
        left: 8px;
        border: 0px;
        color: #1C4DB2;
      }
      .cancel-btn {
        float: left;
        left: 5px;
        border: 0px;
        color: #1C4DB2;
      }
      .reset-btn:hover {
        border-color: #1C4DB2 !important;
        color: #1C4DB2 !important;
        text-decoration:underline;
      }
      .cancel-btn:hover {
        border-color: #1C4DB2 !important;
        color: #1C4DB2 !important;
        // text-decoration:underline;
      }
      .el-button.is-plain:focus, .el-button.is-plain:hover {
        border-color: var(--site-font-drop-down-secondary-color);
        color: var(--site-font-drop-down-secondary-color)
      }
    }
  }
  
</style>